import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#66bb6a'
        // secondary: colors.red.lighten4,
        // accent: colors.indigo.base
      }
    }
  }
};

export default new Vuetify(opts);
